const formatAge = (ageMonths, ageYears) => {
  const ageMonthsInt = parseInt(ageMonths);
  const ageYearsInt = parseInt(ageYears);
  let years = Math.floor(ageMonthsInt / 12) + ageYearsInt;
  if (ageMonthsInt < 0) {
    years = Math.ceil(ageMonthsInt / 12) + ageYearsInt;
  }
  const months = ageMonthsInt % 12;
  return { years, months };
};

export default formatAge;
